import React from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink } from "react-router-dom";

export class MaratonProgress extends React.Component {




    constructor(props) {
        super(props);
        this.circleDiv = React.createRef();
    }

    componentDidMount() {
        this.circle = new ProgressBar.Circle(this.circleDiv.current, {
            color: '#fff',
            trailColor: 'rgba(0,0,0,.2)',
            duration: 800,
            easing: 'linear',
            strokeWidth: 8,
            trailWidth: 8,
        });
    }

    componentWillUnmount() {
        if (this.circle)
            this.circle.destroy();
    }



    render() {

        if (this.circle && this.props.progress >= 0)
            this.circle.animate(this.props.progress / 100.0);


        if (this.circle && this.props.progress == -1)
            this.circle.animate(0);


        return <div className="maraton-timer">
            <div key='i1' className="maratonTimer maratonProgress center-verticaly">
                {this.props.progress != -1 && this.props.progress + '%'}
                {this.props.progress == -1 && <img key='i2' src='content/images/assets/ic_bonus_finished.png'></img>}
            </div>
            <div key='i3' id="circle2" ref={this.circleDiv} className="progress"></div>
        </div>

    }


};
